module.exports = require("./qu.js");